import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, IconButton, Tooltip, Typography,
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {
  CardWrapper, ButtonUI, ButtonOutlined, Field,
} from '../../UI';
import { BlocoEnderecos, BlocoTelefones } from './BlocosCadastrais';
import * as C from '../../../theme/colors.constants';

/**
 * Aba Cliente — print `grid_check_cliente.png`.
 *
 * Mesmo esqueleto da aba Devedor, com o bloco "Identificação" e o avatar no
 * canto direito do cabeçalho.
 */
export default function AbaCliente({ processo }) {
  return (
    <CardWrapper>
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, flexWrap: 'wrap',
      }}
      >
        <PersonOutlineIcon sx={{ color: C.navy }} />
        <Typography variant="h2" sx={{ flex: 1 }}>Cliente</Typography>
        <ButtonOutlined size="small">VISUALIZAR DOCUMENTO</ButtonOutlined>
        <ButtonOutlined size="small">CONSULTAR CLIENTE</ButtonOutlined>
        <ButtonUI size="small">ALTERAR</ButtonUI>
        <Tooltip title="Preposto do cliente" arrow>
          <IconButton size="small" sx={{ color: C.navy }}>
            <AccountCircleOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Typography variant="h3" sx={{ mb: 1.5 }}>Identificação</Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Código:" value="10" />
        <Field label="Nome:" value={processo?.nomeCliente || ''} />
        <Field label="Origem Laad:" />
        <Field label="Status:" tipo="select" options={['Ativo', 'Inativo', 'Bloqueado']} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, 1fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Nome Fantasia:" value={processo?.nomeCliente || ''} />
        <Field label="Código do cliente:" value="16 38777100" />
        <Field label="Inscrição estadual:" />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Categoria:" tipo="select" options={['Pessoa Jurídica', 'Pessoa Física']} />
        <Field label="CNPJ/CPF:" />
        <Field label="Preposto:" />
        <Field label="Inscrição municipal:" />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(3, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Filial responsável:" tipo="select" options={['Matriz', 'Filial São Paulo', 'Filial Ribeirão Preto']} />
        <Field label="Telemarketing:" tipo="select" options={['Sim', 'Não']} />
        <Field label="Ramos de atividade:" tipo="select" options={['Comércio', 'Indústria', 'Serviços']} />
      </Box>

      <Box sx={{ mt: 'clamp(10px, 0.8vw, 22px)' }}>
        <Field label="Comercial principal:" />
      </Box>
      <Box sx={{ mt: 'clamp(10px, 0.8vw, 22px)' }}>
        <Field label="Observações:" multiline minRows={4} />
      </Box>

      <BlocoEnderecos />
      <BlocoTelefones />

      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3,
      }}
      >
        <ButtonOutlined>CANCELAR</ButtonOutlined>
        <ButtonUI>GRAVAR</ButtonUI>
      </Box>
    </CardWrapper>
  );
}
AbaCliente.propTypes = { processo: PropTypes.object };
AbaCliente.defaultProps = { processo: null };
